/**
 * Run a function lazily.  The function supplied as a getter will only ever be called once.  
 * The value will be cached and returned whenever the resulting function is called.
 * @param {Function} getter The function that will be called to get the value to return
 * @returns {Function} A function that returns the cached value.
 */
export let lazy = function<T>(getter: () => T): () => T
{
    var initialized = false;
    var value: T | undefined;
    return function ()
    {
        if (!initialized)
        {
            value = getter();
            initialized = true;
        }
        return value!;
    };
};
